
export const Paths = {
    login_privy: `/login/privy`,
    login: 'login',
    wallet_user_balance: `/wallet_user/balance`,
    wallet_user: '/wallet_user',
    wallet_user_trasaction: `/wallet_user/transaction`,
    wallet_user_send_to: `/wallet_user/send_to`,
    wallet_user_quote : '/wallet_user/quote',
}
